export class ListData {
  canAdd!: boolean;
  pageIndex!: number;
  totalCount!: number;
  pageSize!: number;
  pageData!: {
    canDelete: boolean
    canEdit: boolean
    created: string
    id: number
    name: string
    numberOfTable: number
    tables: number
    title_AR: string
    title_EN: string
    totalCovers: number
    availableTableOnline: string
    coversOnline: string
    updated: string
    isActive: boolean
  }[];
}

export class Record {
  id!: string
  title_EN!: string
  title_AR!: string
  restaurantsId!: number
}

export class ListFilter {
  pageSize!: number;
  pageNumber!: number;
  sortItems!: sortList;
  searchText!: string;
  createdFrom!: Date;
  createdTo!: Date;
  restaurantId!: number;
}

export enum sortList {
  Name = 0,
  NewestCreate = 1,
  OldestCreate = 2,
  HighestUse = 4,
  LowestUse = 3,
  Highest_Amount = 5,
  Lowest_Amount = 6
}
